<template>
  <VisionButton
    v-bind="$attrs"
    :to="resolvedTo"
    @click="handleClick"
  >
    <template #content>
      <slot name="content" />
    </template>
  </VisionButton>
</template>

<script setup>
const props = defineProps({
  to: { type: String, default: null }
})

const modalStore = useModalStore()
const emit = defineEmits(['click'])
const { $scrollTo } = useNuxtApp()

const resolvedTo = props.to?.startsWith('@scroll:') || props.to?.startsWith('@modal:')
  ? undefined
  : props.to

function handleClick(event) {
  if (props.to?.startsWith('@scroll:')) {
    event.preventDefault()
    return $scrollTo('#' + props.to.replace('@scroll:', ''))
  } else if (props.to?.startsWith('@modal:')) {
    event.preventDefault()
    return modalStore.OPEN_MODAL_PAGE({
      slug: props.to.replace('@modal:', ''),
    })
  }

  emit('click', event)
}
</script>